var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.75C0 1.38533 0.125111 1.03559 0.347811 0.777728C0.57051 0.519866 0.872555 0.375 1.1875 0.375H17.8125C18.1274 0.375 18.4295 0.519866 18.6522 0.777728C18.8749 1.03559 19 1.38533 19 1.75V18.25C19 18.6147 18.8749 18.9644 18.6522 19.2223C18.4295 19.4801 18.1274 19.625 17.8125 19.625H1.1875C0.872555 19.625 0.57051 19.4801 0.347811 19.2223C0.125111 18.9644 0 18.6147 0 18.25V1.75ZM10.0938 1.75V12.75H17.8125V1.75H10.0938ZM10.0938 14.125V18.25H17.8125V14.125H10.0938ZM8.90625 1.75H1.1875V5.875H8.90625V1.75ZM1.1875 18.25H8.90625V7.25H1.1875V18.25Z",
    fill: "#6F767D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.b9955310c79af4518c2e9b2a83280575.svg";
export { ForwardRef as ReactComponent };